import { DialogActions } from '../../dialog';
import { styled } from '../../styled';
export var SelectMenuActions = styled(DialogActions, { name: 'QuantumSelectMenuActions' })(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
        justifyContent: 'flex-end',
    });
});
